export enum CardType {
    NENHUM,
    CARTEIRAS_PROCESSADAS,
    CARTEIRAS_NAO_PROCESSADAS,
    ENQUADRADA,
    DESENQUADRADA,
    REGRAS_PROCESSADAS,
    REGRAS_NAO_PROCESSADAS,
    COM_REGRAS,
    SEM_REGRAS,
    CANCELADO
}
